var AdditionalWorkModelV2 = function (pageModelHndl) {
    var that = this;

    that.IsLoading = ko.observable(false);
    that.IsDependencyLoading = ko.computed(function () {
        return pageModelHndl.pPriceTableModelV2.IsLoading()
            || pageModelHndl.pPriceTableModelV2.IsDependencyLoading();
    }, this, {pure: true});

    that.SelectedAdditionalWork = ko.observableArray([]);

    var getAdditionalWork = function (array, additionalWorkId) {
        for (var i = 0, length = array.length; i < length; i++) {
            if (array[i] === additionalWorkId) {
                return array[i];
            }
        }
    };

    that.addSelectedAdditionalWork = function (additionalWorkId) {
        if (that.SelectedAdditionalWork().length > 0) {
            var result = getAdditionalWork(that.SelectedAdditionalWork(), additionalWorkId);
            if (result) {
                that.SelectedAdditionalWork.remove(result);
                return;
            }
        }
        that.SelectedAdditionalWork.push(additionalWorkId);
    };

    var updateOrderAdditionalWorkOptions = function (input) {
        var url = $("#productConfigurationAdditionalWork").data("url");

        that.IsLoading(true);
        return $.ajax({
            type: "POST",
            contentType: "application/json",
            url: url,
            data: input,
            datatype: "html"
        }).done(function (result) {
            $("#additionalWorkContainer").html(result);
        }).fail(function () {
            alerts.error();
        }).always(function () {
            that.IsLoading(false);
        });
    };

    that.LoadAdditionalWorkData = function () {
        var input = JSON.stringify({
            selectedOrderOptions: pageModelHndl.pOrderOptionsModelV2.SelectedOrderOptions(),
            selectedDeliveryCountry: pageModelHndl.pOrderOptionsModelV2.SelectedDeliveryCountryId(),
            articlereference: pageModelHndl.pPriceTableModelV2.ArticleReference(),
            amount: pageModelHndl.pPriceTableModelV2.Amount(),
            isCatalogueProduct: pageModelHndl.IsCatalogueProduct(),
            selectedAdditionalWorkIds: that.SelectedAdditionalWork()
        });

        return updateOrderAdditionalWorkOptions(input);
    };

    var updateConfigurationSummary = function () {
        return pageModelHndl.pSummaryModel.load(
            pageModelHndl.pPriceTableModelV2.ArticleReference(),
            pageModelHndl.pPriceTableModelV2.Amount(),
            pageModelHndl.pOrderOptionsModelV2.SelectedOrderOptions(),
            pageModelHndl.pOrderOptionsModelV2.SelectedDeliveryCountryId(),
            that.SelectedAdditionalWork());
    };

    $(function () {
        var contextElement = $("#productConfigurationMainDiv");
        contextElement.on("click", ".OrderOptionList .additional-work-click input",
            function () {
                var additionalWorkId = $(this).parent().parent().data("additionalworkid");
                that.addSelectedAdditionalWork(additionalWorkId, $(this).val());
                updateConfigurationSummary();
            });
    });

    $(function () {
        var contextElement = $("#productConfigurationMainDiv");
        contextElement.on("click", ".additional-work-click label",
            function () {
                var additionalWorkId = $(this).parent().data("additionalworkid");
                that.addSelectedAdditionalWork(additionalWorkId, $(this).val());
                that.SyncCheckbox(additionalWorkId);
                updateConfigurationSummary();
            });
    });

    that.SyncCheckbox = function (additionalWorkId) {
        var el = $(".additional-work-click[data-additionalWorkId='" + additionalWorkId + "'] :input");
        if (el.prop("checked")) {
            el.prop("checked", false);
        } else {
            el.prop("checked", true);
        }
    }
}